import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@/lib/auth';
import { client } from '../../lib/amplify-client';

export interface SubmitFeedbackResult {
  feedback_id: string;
  created_at: string;
}

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument */
export function useSubmitFeedbackMutation() {
  // Pick auth mode based on signed-in state so authenticated submissions
  // forward Cognito identity to the Lambda; guests use the public API key.
  const { authStatus } = useAuth();
  const authMode: 'userPool' | 'apiKey' =
    authStatus === 'authenticated' ? 'userPool' : 'apiKey';

  return useMutation({
    mutationFn: async (input: { message: string }): Promise<SubmitFeedbackResult> => {
      const result = await (client.mutations as any).submitFeedback(input, {
        authMode,
      });
      if (result.errors?.length) throw new Error(result.errors[0].message);
      return result.data as SubmitFeedbackResult;
    },
  });
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument */
